// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var ReactDnd = require("react-dnd");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");

function Make(I) {
  var fromItem = function (item) {
    return {
            type: I.type_(item),
            item: item
          };
  };
  var toItem = function (js) {
    return js.item;
  };
  var JsItem = {
    fromItem: fromItem,
    toItem: toItem
  };
  var getItem = function (t) {
    return Core__Option.map(Caml_option.nullable_to_opt(t.getItem()), toItem);
  };
  var isDragging = function (t) {
    return t.isDragging();
  };
  var getItemType = function (t) {
    return Caml_option.nullable_to_opt(t.getItemType());
  };
  var DragSourceMonitor = {
    getItem: getItem,
    isDragging: isDragging,
    getItemType: getItemType
  };
  var getItem$1 = function (t) {
    return Core__Option.map(Caml_option.nullable_to_opt(t.getItem()), toItem);
  };
  var getClientOffset = function (t) {
    return Caml_option.nullable_to_opt(t.getClientOffset());
  };
  var DropTargetMonitor = {
    getItem: getItem$1,
    getClientOffset: getClientOffset
  };
  var ConnectableElement = {};
  var DragSource = {};
  var DropTarget = {};
  var useDrag = function (begin_, collect, item, param) {
    var item$1 = fromItem(item);
    return ReactDnd.useDrag({
                collect: collect,
                begin: begin_,
                item: item$1
              });
  };
  var useDrop = function (collect, hover, accept, param) {
    var hover$1 = Core__Option.map(hover, (function (h) {
            return function (item, monitor) {
              h(item.item, monitor);
            };
          }));
    return ReactDnd.useDrop({
                accept: accept,
                collect: collect,
                hover: hover$1
              });
  };
  return {
          JsItem: JsItem,
          DragSourceMonitor: DragSourceMonitor,
          DropTargetMonitor: DropTargetMonitor,
          ConnectableElement: ConnectableElement,
          DragSource: DragSource,
          DropTarget: DropTarget,
          useDrag: useDrag,
          useDrop: useDrop
        };
}

exports.Make = Make;
/* react-dnd Not a pure module */
